import { MESApiService, type spParameter } from "@dexteel/mesf-core";

export const getHeats = async () => {
  const apiService = new MESApiService();

  try {
    const resp = await apiService.call("[MS].[GetHeats]", []);
    return {
      ok: true,
      data: resp,
    };
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};
export const getHeat = async (HeatId: number) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [];

  parameters.push({ name: "HeatId", value: HeatId });

  return await apiService.callV2("[RBD].[GetHeat]", parameters);
};
export const getLastHeat = async () => {
  const apiService = new MESApiService();
  try {
    const resp = await apiService.call("[MS].[GetLastHeat]", []);
    if (resp.errorMessage !== null)
      return { ok: false, message: resp.errorMessage };
    return {
      ok: true,
      data: resp,
    };
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};
export const searchHeatNames = async (searchText: string) => {
  try {
    var sqlParameters = [];
    sqlParameters.push({ name: "@SearchText", value: searchText.trim() });

    const apiService = new MESApiService();
    const resp = await apiService.call("[MS].[SearchHeatNames]", sqlParameters);
    if (resp.errorMessage !== null)
      return { ok: false, message: resp.errorMessage };
    return {
      ok: true,
      data: resp,
    };
  } catch (e: any) {
    return { ok: false, message: e.toString() };
  }
};
